// src/constants/PricingPlans.js

const plans = [
  {
    type: "Yearly Subscription",
    price: "$49",
    period: "/year",
    features: [
      "Unlock 4K HD!",
      "Create and download unlimited videos!",
      "All Downloaded videos are Watermark FREE!",  
    ],
    button: "Subscribe",
    buttonStyle:
      "bg-pink-400 hover:bg-pink-500 text-white font-bold duration-150",
    highlight: true,
    details: "Best for creators",
  },
];

export default plans;
